export enum CheckboxType {
  checkbox = 'checkbox',
  radio = 'radio'
}
